import React from 'react';
import { IconProps } from './types';

const User: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M22.462 10.104c0 4.282-2.9 7.752-6.478 7.752s-6.478-3.471-6.478-7.753c0-4.282 2.9-7.753 6.478-7.753s6.478 3.471 6.478 7.753z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M27.827 26.019v0-2.508c0-3.562-2.779-6.469-6.287-6.686-1.428 1.69-3.389 2.735-5.556 2.735-2.176 0-4.147-1.053-5.575-2.757h-0.020c-3.705 0-6.707 3.003-6.707 6.708v2.584h0.018c0.039 0.553 0.496 0.991 1.063 0.991l22.007-0.002c0.592 0 1.070-0.476 1.070-1.065h-0.012z"
    />
  </svg>
);

export default User;
